export type RegistrationTrackingData = {
  utmCampaign: string;
  utmSource: string;
  utmContent: string;
  utmMedium: string;
  utmTerm: string;
  pageUrl: string;
};
export const getRegistrationTrackingData = (searchParams: URLSearchParams): RegistrationTrackingData => {
  return {
    utmCampaign: searchParams.get('utm_campaign') || '',
    utmSource: searchParams.get('utm_source') || '',
    utmContent: searchParams.get('utm_content') || '',
    utmMedium: searchParams.get('utm_medium') || '',
    utmTerm: searchParams.get('utm_term') || '',
    pageUrl: searchParams.get('parentUrl') || '',
  };
};
